"use client";
import { IMAGES } from '@/constants/constants'
import Image from 'next/image'
import Link from 'next/link';
import React from 'react'

// CSS for rounded triangles
const triangleStyles = `
  .tri-container-up {
    --r: 8px; /* radius for rounded corners */
    aspect-ratio: 1/cos(30deg);
    overflow: hidden;
    -webkit-mask:
      conic-gradient(from -30deg at 50% calc(200% - 3*var(--r)/2), #000 60deg, #0000 0)
        0 100%/100% calc(100% - 3*var(--r)/2) no-repeat,
      radial-gradient(var(--r) at 50% calc(2*var(--r)), #000 98%, #0000 101%),
      radial-gradient(var(--r), #000 98%, #0000 101%) space no-repeat
        0 100%/calc(2*tan(60deg)*var(--r)) calc(2*var(--r));
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
  }
  
  .tri-container-down {
    --r: 8px; /* radius for rounded corners */
    aspect-ratio: 1/cos(30deg);
    overflow: hidden;
    -webkit-mask:
      conic-gradient(from 150deg at 50% calc(3*var(--r)/2 - 100%), #000 60deg, #0000 0)
        0 0/100% calc(100% - 3*var(--r)/2) no-repeat,
      radial-gradient(var(--r) at 50% calc(100% - 2*var(--r)), #000 98%, #0000 101%),
      radial-gradient(var(--r), #000 98%, #0000 101%) space no-repeat
        0 0/calc(2*tan(60deg)*var(--r)) calc(2*var(--r));
    clip-path: polygon(50% 100%, 100% 0, 0 0);
  }
  
  .tri-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  .group:hover .tri-image {
    transform: scale(1.1);
  }
`

const OtherResources = () => {
    const resources = [
        {
            id: 1,
            title: "FARES",
            image: IMAGES.re1,
            alt: "Ferry fares information",
            link: "/fares"
        },
        {
            id: 2,
            title: "SCHEDULE",
            image: IMAGES.re2, // Using same image as placeholder
            alt: "Ferry schedule information",
            link: "/schedule"
        },
        {
            id: 3,
            title: "FAQ",
            image: IMAGES.re3, // Using same image as placeholder
            alt: "Frequently asked questions" ,
            link: "/faq"
        },
        {
            id: 4,
            title: "CONTACT US",
            image: IMAGES.re4, // Using same image as placeholder
            alt: "Contact information",
            link: "/contact-us" 
        }
    ]

    return (
        <div className="bg-skin py-16 px-6 hidden md:block">
            {/* Add CSS styles for rounded triangles */}
            <style jsx>{triangleStyles}</style>

            <div className="max-w-6xl mx-auto">
                {/* Section Title */}
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-800 mb-12">
                    OTHER RESOURCES
                </h2>

                {/* Triangle Cards Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 justify-items-center relative">
                    {resources.map((resource, index) => {
                        const isUpward = index % 2 === 0;

                        return (
                            <Link href={resource.link} key={resource.id}>
                            <div  className="group cursor-pointer relative z-10 hover:z-20  ">
                                {/* Triangle Container with CSS mask for rounded corners */}
                                <div className="relative w-100 h-100 flex items-center justify-center">
                                    <div className="relative w-90 h-90">
                                        <div className={isUpward ? 'tri-container-up' : 'tri-container-down'}>
                                            <Image
                                                src={resource.image}
                                                alt={resource.alt}
                                                width={300}
                                                height={300}
                                                className="tri-image"
                                            />
                                        </div>

                                        {/* Title positioning based on triangle direction */}
                                        <div className={`absolute left-0 right-0 flex items-center justify-center z-10 ${isUpward ? 'bottom-15' : 'top-5'
                                            }`}>
                                            <h3 className="text-white font-rakesly text-xl md:text-2xl font-bold text-center px-4 tracking-wide drop-shadow-lg">
                                                {resource.title}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </Link>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default OtherResources